import { ButtonList, Tooltip } from '@dixa/lib-shared-habla';
import { User } from 'lib-shared-types-api';
import { useCallback, useMemo } from 'react';

import { appActions } from 'app/app.actions';
import { validateIfUserCanMerge } from 'app/views/layout/utils/validateIfUserCanMerge/validateIfUserCanMerge';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

export type MergeContactsActionProps = {
  /** The user that will be used as target user */
  user: User;
  /** Toggle the parent dropdown between open and closed */
  toggleDropdown: () => void;
};

/**
 * Merge contacts action
 *
 * A dropdown menu item that opens the merge contacts modal.
 */
export const MergeContactsAction = ({
  user,
  toggleDropdown,
}: MergeContactsActionProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const canUserMergeValidation = useMemo(
    () => validateIfUserCanMerge(user),
    [user],
  );

  const showMergeContactsModal = useCallback(
    (user: User) => {
      dispatch(
        appActions.showModal({
          modal: { type: 'app:mergeContacts', arg: { user } },
        }),
      );
    },
    [dispatch],
  );

  const handleOnItemClick = () => {
    showMergeContactsModal(user);
    toggleDropdown();
  };

  return (
    <Tooltip
      content={canUserMergeValidation.reason}
      disabled={canUserMergeValidation.valid}
      dark={true}
      side="left"
    >
      <ButtonList.Item
        icon="combine"
        onClick={() => handleOnItemClick()}
        isDisabled={!canUserMergeValidation.valid}
      >
        Merge contact
      </ButtonList.Item>
    </Tooltip>
  );
};
